import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Spinner, Table } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/tunjangankinerjaService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

import IndexBloc from "../Blocs/IndexBlock"

class TableAbsensiPerOrang extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    source
    historyTable = 'historyLemburTableActive'
    defaultOrder = 'presensi_result_date'
    defaultSize = 999999
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            syncUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 999999,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    exportExcel = () =>{
        let additionalFilter = this.props.additionalFilter;
        // alert(additionalFilter)
        if(additionalFilter.report_type==10 && additionalFilter.employee_uuid != undefined){
            console.log(additionalFilter)
            this.indexBloc.fetchAbsensiPerorangExport({
                ...additionalFilter
            });
        }else{
            alert("Pegawai Harus dipilih..!")
        }
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.syncData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.indexBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.indexBloc.exportChannel.unsubscribe()
    }

    render() {
        return (
            <>

                {/* <div className="table-responsive">
                    <label htmlFor="">Tabel Kehadiran Perorang</label>
                    <Table
                        className="table table-striped table-bordered table-hover"
                    >
                        <thead className="table-primary">
                            <tr>
                                <th className="text-center" width="*">No</th>
                                <th className="text-center" width="*">Tanggal</th>
                                <th className="text-center" width="*">Jam Masuk</th>
                                <th className="text-center" width="*">Jam Pulang</th>
                                <th className="text-left" width="*">Status Kehadiran</th>
                                <th className="text-center" width="*">Alpha</th>
                                <th className="text-center" width="*">S Finger</th>
                                <th className="text-center" width="*">Terlambat</th>
                                <th className="text-center" width="*">P Awal</th>
                            </tr>                        
                        </thead>
                        <tbody>
                            {
                                this.state.loadingTable == false ?
                                    this.state.rows.length > 0 ? 

                                        this.state.rows.map((data, index) => {
                                            return (
                                                <tr>
                                                    <td>{index+=1}</td>
                                                    <td>
                                                        <b>{data.presensi_result_employee_nip}</b> <br /> {data.presensi_result_employee_name} <br />
                                                    </td>

                                                    <td>{data.presensi_result_day_name === null ? '-' : data.presensi_result_day_name}</td>
                                                    <td>{this.dateParse(data.presensi_result_date)}</td>
                                                    <td>{data.presensi_result_checkin === null ? '-' : data.presensi_result_checkin}</td>
                                                    <td>{data.presensi_result_checkout === null ? '-' : data.presensi_result_checkout}</td>
                                                </tr>
                                            );
                                        })
                                    : 
                                    <tr>
                                        <td colSpan="6" className="text-center">Tidak Ada Data</td>
                                    </tr>
                                :
                                <tr>
                                    <td colSpan="6" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </div> */}
                
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diproses"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diproses"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/rekap_absensi.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableAbsensiPerOrang